import { ActionType } from "../../model/actionTypes";
import { errorHandler } from "./auth";

export const getOdFeeSchedules = (practiceIds: number[], params?: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const query = { practiceIds: JSON.stringify(practiceIds), ...params };
        const resp = await api.get("openDental/feeSchedules", null, query);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch(errorHandler(err));
        return [];
    }
};

export const createOdFeeSchedule = (data: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp = await api.post("openDental/feeSchedule", data, null);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch({ type: ActionType.ALERT, payload: err });
        return {};
    }
};

export const updateOdFeeSchedule = (data: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp = await api.put("openDental/feeSchedule", data, null);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch({ type: ActionType.ALERT, payload: err });
        return {};
    }
};
